<template>
  <div class="animated fadeIn">
    <b-row>
        <b-col sm="12">
          <assessment-form
            v-bind:assessment="assessment"
            :locations="organization.locations"
            :programs="organization.programs"
            v-on:addOrUpdate="addOrUpdate">
          </assessment-form>
          <b-card v-if="!_.isEmpty(errors)">
              {{ errors }}
          </b-card>
        </b-col>
    </b-row>
    <b-modal v-if="createdAssessment.id" title='Success' @ok="handleOk" header-bg-variant="success" header-text-variant="light" size="sm" :visible="showAssessmentCreatedModal" centered id="modal1" ok-only>
        <h4>Lighthouse Indicator Record Created Successfully</h4>
        <p>{{ createdAssessment.id }}</p>
    </b-modal>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import assessmentForm from '@/views/t1/AssessmentForm'

export default {
  name: 'addassessment',
  components: {
    assessmentForm
  },
  computed: {
    ...mapGetters({
      assessment: 'getCreateAssessment',
      createdAssessment: 'getRecentlyCreatedAssessment',
      showAssessmentCreatedModal: 'showAssessmentCreatedModal',
      userCurrentContext: 'userCurrentContext',
      organization: 'getViewOrganization'
    })
  },
  methods: {
    handleOk (evt) {
      if (this.createdAssessment.id) {
        this.$router.push({ path: `/screening/${this.createdAssessment.id}` })
      } else {
        this.$router.push({ path: `/dashboard` })
      }

      // Reset pieces of state
      this.$store.commit('setShowAssessmentCreatedModal', false)
      this.$store.commit('resetCreateAssessment', null)
    },
    addOrUpdate () {
      var personId = this.$route.params.id

      this.$validator.validate().then(result => {
        if (result) {
          let values = this._.pickBy(this.assessment, this._.identity)
          values.person_id = personId

          if (this._.isObject(values.location)) {
            values.location = values.location.id
          }

          if (this._.isObject(values.program)) {
            values.program = values.program.id
          }

          this.$store.dispatch('createAssessment', values)
        }
      })
    }
  },
  watch: {
    organization: function (newValue) {
      this.assessment.location = newValue.defaultLocation
      this.assessment.program = newValue.defaultProgram
    }
  },
  created () {
    const organizationId = this.userCurrentContext.organization.id
    this.$store.dispatch('getOrganizationView', {
      id: organizationId
    })
  },
  data: function () {
    return {
      errors: []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/t1/Admin/AddAssessment.vue